import { useEffect, useState } from "react";

const useCountUp = (duration: number, value: number) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start: number | null = null;
    const endValue = Number(value);

    const step = (timestamp: number) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      setCount(Math.floor(progress * endValue));

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [duration, value]);

  return count;
};

export default useCountUp;


